import { FC, PropsWithChildren } from 'react';
import {
  PageContentLayout,
  PageHeaderLayout,
  SideMenu,
} from 'melp-design/components';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router-dom';
import { ROUTES } from 'config';

export const AlternativesLayout: FC<PropsWithChildren<{}>> = ({ children }) => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();

  return (
    <Stack gap={2}>
      <PageHeaderLayout
        breadcrumbs={[
          {
            label: t('alternatives.alternatives'),
          },
        ]}
      />

      <PageContentLayout
        sidebar={
          <SideMenu
            tabs={[
              {
                key: 'alternatives',
                label: t('alternatives.alternatives'),
                url: ROUTES.alternatives.list,
                isActive: path === ROUTES.alternatives.list,
              },
            ]}
          />
        }
      >
        {children}
      </PageContentLayout>
    </Stack>
  );
};
